const commonLang = {
  EDIT: ['EDIT', '编辑'],
  YES: ['YES', '是'],
  NO: ['NO', '不'],
  Active: ['Active', '开启'],
  Deactiva: ['Deactiva', '关闭'],
  Cancel: ['Cancel', '取消'],
  Confirm: ['Confirm', '确定'],
  OK: ['OK', '关闭'],
};
export default commonLang;
